import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from 'src/app/core/core.module';

import { UserDropdownComponent } from '../user-dropdown/user-dropdown.component';
import { NavComponent } from './nav.component';

@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    RouterModule,
    IonicModule,
    TranslateModule
  ],
  exports: [
    NavComponent,
  ],
  declarations: [
    NavComponent,
    UserDropdownComponent
  ],
  providers: [],
})
export class NavModule { }
